export var now = function () {
    return Date.now ? Date.now() : +(new Date());
};



// WEBPACK FOOTER //
// ./node_modules/moment/src/lib/moment/now.js